// let rxp_viewdata = /^\$viewData(\.|\[.+\])/g
import * as common from "./common/layoutViewCommon";

let form = {
  provide() {
    return {
      $form: this
    };
  },
  props: {
    params: {
      type: Object,
      default() {
        return {};
      }
    },
    //表单执行loadData时不向服务器发送请求而使用localData传进来的数据
    localData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      _isForm: true,
      loading: false,
      isView: false,
      ignoreValidate: false,
      validating: false,
      _errors: {},
      savedCloseTime: 1000
      // formItemInnerValidates: {}
    };
  },
  beforeCreate() {},
  created() {
    this.$updateForceReadOnly();
  },
  dataLoaded(data, next) {
    next();
  },
  beforeDestroy() {
    for (const k in this.metaDataAndCtrls) {
      delete this.metaDataAndCtrls[k];
    }
    this.metaDataAndCtrls = null;
  },
  methods: {
    $updateForceReadOnly() {
      this.$data.$forceReadOnly = this.queryString.isview == 1;
    },
    //调用数据加载接口
    $loadData() {
      if (this.localData) {
        return Promise.resolve({
          data: this.localData
        });
      }
      let copyFormId = this.queryString.copyFormId
      if (this.$dataKey || copyFormId) {
        let params = {
          ...this.queryString,
          pageName: this.pageName,
          namespace: this.nameSpace,
        }
        params.data = JSON.stringify({
          _id:  this.$dataKey || copyFormId
        })
        if(!this.$dataKey){
          params.id = copyFormId;
          params.copy = 1;
        }
        return this.$getFormDataAPI(params).then((result) => result.data);
      }
      return Promise.resolve();
    },
    //表单提交操作后的更新
    async $updateData() {
      try {
        this.loading = true;
        await this.setInitData();
        let data = await this.$loadData();
        await this.setViewData(data?.data);
      } catch (error) {
        dsf.httpError(error, { isSilent: true });
      } finally {
        this.loading = false;
      }
    },
    // 初始化表单数据
    async setInitData() {
      let initData = await this.$initData();
      dsf.mix(this.context.$$viewInitData, initData);
    },
    // 为表单赋值
    setViewData(data) {
      let viewData = this.$initControls(this);
      data = dsf.mix(viewData, data || null);
      for (const k in viewData) {
        let m = this.metadataDict[k];
        if (m && m.type == "subtable") {
          let rows = viewData[k] || [];
          rows.forEach((row) => {
            if (dsf.isUnDef(row.$hash)) {
              row.$hash = dsf.uuid();
            }
          });
        }
      }
      this.context.$$viewData = data;
      common.mergeExecCycleFunctions(this, "updateData", [], common.postPromiseFn);
    },
    //表单验证（不触发验证前后的钩子）
    async validate(vdatakey, index) {
      const { metadataDict: dict, $metadataKeyList: allKeys } = this;
      let keys = [];
      //全局验证
      if (arguments.length == 0) {
        keys = allKeys.filter((it) => {
          return !dict[it].inSubTable;
        });
      } else {
        keys = dsf.type(vdatakey) == "array" ? vdatakey : [vdatakey];
      }
      let arrs = this?.$getValidateFns?.(keys, dict, index);
      return await this?.$execValidateFns?.(arrs);
    },
    //表单验证（触发验证前后的钩子）
    async formValidate(opt) {
      this.validating = true;
      // let validateBefore = this.$options.validateBefore;
      //表单验证后触发
      // let validateAfter = this.$options.validateAfter;
      try {
        await common.mergeExecCycleFunctions(this, "validateBefore", [opt], common.postPromiseFn);
        if (!this.ignoreValidate) {
          //执行验证函数
          await this.validate();
        }
        this.clearErrors();
      } catch (ex) {
        let err = ex;
        if (dsf.isArray(err)) {
          this.pushError(err);
          this.$scrollToError(err);
          // 兼容 公式审核 如果有 强制性和表单型的错误才阻止表单提交
          if (err.length) {
            if (err.filter((item) => !item?.info?.ignore).length) {
              this.$emit("open-audit-state");
              err = {
                type: "ValidateError",
                result: ex,
                message: "表单校验错误"
              };
              throw err;
            } else if (!opt.isSkipIgnore) {
              this.$emit("open-audit-state");
              throw "请确认忽略性错误";
            }
          }
        } else {
          throw err;
        }
      } finally {
        await common.mergeExecCycleFunctions(this, "validateAfter", [opt], common.postPromiseFn);
        this.validating = false;
      }
    },
    /**
     * 验证组件
     * @param {*} value
     * @param {*} index
     * @param {*} field
     * @returns
     */
    async validateField(value, index, field) {
      let errors = [];
      if (!field) {
        return;
      }
      try {
        if (!field.isOneToMany) {
          //主表或者子表中单个表单组件验证
          this?.removeErrorsByTarget?.(field.$formName);
          await this?.validate?.(field.formName, index);
        } else {
          //如果是子表整表或者指定行验证
          let subTableKey = field.formName;
          let subKeys = _.filter(this.$metadataKeyList, (it) => {
            return this.metadataDict[it].inSubTable == subTableKey;
          });
          let rows = value;
          //如果指定了行，则使用行验证
          if (dsf.isDef(index)) {
            rows = [value[index]];
          }
          _.each(rows, (row) => {
            this.removeErrorsByRowHash(row.$hash);
          });
          await this.validate(field.formName, index);
        }
        return [];
      } catch (err) {
        if (dsf.type(err) == "array") {
          this.pushError(err);
        }
        return err;
      }
    },
    /**
     * 重置校验
     */
    resetValidate() {
      var fields = this.allComponents;
      this.clearErrors();
      _.each(fields, (field) => {
        field.errors = [];
      });
    },
    /**
     * 添加表单组件,表单类组件创建时候会调用此函数
     * @param {*} ctrl
     */
    $addFiled(ctrl) {
      const flag = ctrl._isVue;
      flag && this.allComponents.push(ctrl);
      this.$nextTick(() => {
        this.updateMetaDataDict(ctrl);
      });
    },
    /**
     * 表单组件被销毁，表单类组件销毁时候会调用此函数
     * @param {*} ctrl
     */
    $removeFiled(ctrl) {
      const isVue = ctrl._isVue;
      if (this.metadataDict[ctrl.formName]) {
        //refs用来存储组件实例，组件移除时将refs中的实例也移除掉
        if (isVue) {
          dsf.array.remove(this.metadataDict[ctrl.formName].refs || [], ctrl);
        } else {
          dsf.array.remove(this.metadataDict[ctrl.formName].proxyRefs || [], ctrl);
        }
      }
      dsf.array.removeWith(this.allComponents, (it) => it == ctrl);
    },
    /**
     *  更新metadataDict，因为页面中有存在动态创建的组件（子表，动态布局）
     * @param {*} ctrl
     * @returns
     */
    updateMetaDataDict(ctrl) {
      const isVue = ctrl._isVue;
      if (!this.metadataDict) {
        return;
      }
      let { formName, metadata_fullcode: fullCode, metadata } = ctrl;
      if (!isVue) {
        formName = fullCode;
      }
      if (!metadata || !formName) {
        return;
      }
      let arr = formName.split(".");
      let prefix = arr[0];
      let name = arr[1] ? arr[1] : "";
      let isUser = false;
      //子表
      if (ctrl.isOneToMany) {
        if (!this.metadataDict[formName]) {
          this.metadataDict[formName] = {
            type: "subtable",
            fieldsLength: 0,
            valueAttributes: [],
            level: 1,
            refs: []
          };
          isUser = true;
        }
        //refs用来存储组件实例，表单验证时可以判断refs中是否存在组件，如果为空数组则表示该key下没有可以验证的组件
        this.metadataDict[formName].refs = this.metadataDict[formName].refs || [];
        this.metadataDict[formName].valueIsHtml = ctrl.valueIsHtml === true ? true : false;
        this.metadataDict[formName].validate = metadata.validate;
        this.metadataDict[formName].refs.push(ctrl);
        this.metadataDict[formName].allowPost = ctrl.allowPost === false ? false : true;
        // dsf.array.ensure(this.metadataKeyList, formName);
      } else {
        //主表或者子表内的表单组件
        if (!this.metadataDict[formName]) {
          this.metadataDict[formName] = {
            type: "field",
            fieldsLength: metadata.valueAttributes && metadata.valueAttributes.length,
            level: 0,
            valueAttributes: _.map(metadata.valueAttributes, "code"),
            refs: [],
            proxyRefs: []
          };
          isUser = true;
        }
        if (ctrl.$list && this.metadataDict[ctrl.$list.formName]) {
          this.metadataDict[formName].level = 1;
          this.metadataDict[formName].inSubTable = ctrl.$list.formName;
        }
        this.metadataDict[formName].refs = this.metadataDict[formName].refs || [];
        this.metadataDict[formName].proxyRefs = this.metadataDict[formName].proxyRefs || [];
        this.metadataDict[formName].valueIsHtml = ctrl.valueIsHtml === true ? true : false;
        this.metadataDict[formName].validate = metadata.validate;
        if (isVue) {
          this.metadataDict[formName].refs.push(ctrl);
        } else {
          dsf.array.ensure(this.metadataDict[formName].proxyRefs, ctrl);
        }
        this.metadataDict[formName].allowPost = ctrl.allowPost === false ? false : true;
        // dsf.array.ensure(this.metadataKeyList, formName);
      }
      if (this.metadataDict[formName]) {
        this.metadataDict[formName].isUser = isUser;
        if (ctrl.validateRule) {
          this.metadataDict[formName].validateRule = ctrl.validateRule;
        }
      }
    },
    /**
     * 轮询调用所有组件的postBefore
     * @returns
     */
    $postBefore() {
      let arr = [];
      let unitcode = [];
      for (let i = 0; i < this.allComponents.length; i++) {
        const field = this.allComponents[i];
        if (!field.isFormControl) {
          continue;
        }
        const fn = field.postBefore;
        if (field.designId) {
          if (!unitcode[field.$formName] && fn) {
            arr.push(fn());
            unitcode.push(field.$formName);
          }
        } else {
          fn && arr.push(fn());
        }
      }
      return Promise.all(arr);
    },
    /**
     * 轮询调用所有组建的postAfter
     * @param {*} result
     * @returns
     */
    $postAfter(result) {
      let arr = [];
      let unitcode = [];
      for (let i = 0; i < this.allComponents.length; i++) {
        const field = this.allComponents[i];
        if (!field.isFormControl) {
          continue;
        }
        const fn = field.postAfter;
        if (field.designId) {
          //此处判断重复组件，理论上表单的组件时不会重复的，但实际情况可能会使用子表冻结列el-table复制行组件而产生重复
          if (!unitcode[field.$formName] && fn) {
            arr.push(fn(result));
            unitcode.push(field.$formName);
          }
        } else {
          fn && arr.push(fn(result));
        }
      }
      return Promise.all(arr);
    },
    /**
     * 轮询调用所有组建的postError
     * @returns
     */
    $postError() {
      let arr = [];
      let unitcode = [];
      _.each(this.$postFields, (field) => {
        let fn = field.postError;
        if (field.designId) {
          //此处判断重复组件，理论上表单的组件时不会重复的，但实际情况可能会使用子表冻结列el-table复制行组件而产生重复
          if (!unitcode[field.$formName] && fn) {
            arr.push(fn());
            unitcode.push(field.$formName);
          }
        } else {
          fn && arr.push(fn());
        }
      });
      return Promise.all(arr);
    },
    /**
     * 校验后滚动到第一个有错误的控件
     * @param {*} errs
     */
    async $scrollToError(errs) {
      if (!errs) {
        return;
      }
      let clearId = null;
      try {
        // 兼容 公式审核 忽略型的错误不显示并且不滚动到
        let valideResult = (dsf.isArray(errs) ? errs : [errs]).filter(
          (item) => !item?.info?.ignore
        );
        if (valideResult && valideResult.length > 0) {
          let errorObj = valideResult[0];
          let target = errorObj.target;
          let field = null;
          //如果是字符串则使用dom选择器定位
          if (target && dsf.isString(target)) {
            field = this?.$el?.querySelector?.(`[form-name="${target}"]`);
          }
          //如果是dom节点则直接赋值给field
          else if (target && target.nodeType == 1) {
            field = target;
          }
          //如果是vue组件则获取$el属性赋值给field
          else if (target && target.__vue__) {
            field = target?.$el;
          }
          if (field && field.nodeType == 1) {
            let vm = field.__vue__.$parent;
            let el = field;
            let index = 0;
            while (vm && index < 100) {
              if (vm.formScrollIntoViewErrorControl) {
                await vm.formScrollIntoViewErrorControl(el, errorObj);
                el = vm.$el;
              }
              vm = vm.$parent;
              index++;
            }
            clearId = setTimeout(
              () => {
                field.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest"
                });
                clearId && clearTimeout(clearId);
              },
              this.$isMobile ? 400 : 200
            );
          }
        }
      } catch (ex) {
        dsf.error(ex);
        dsf.warn("无法正确定位到错误元素");
      }
    },
    /**
     * 表单保存,更新url，自动关闭
     * @param {*} options
     * @param {*} afterCallback
     * @param {*} isSyncSave
     * @param {*} isReturnYes
     * @returns
     */
    async formSave(options, afterCallback, isSyncSave, isReturnYes) {
      let isAddNew = false;
      if (!this.$dataKey) {
        isAddNew = true;
      }
      options = options || {};
      let opt = {
        isRefresh: false,
        savedClose: false,
        successMsg: "保存成功",
        errorMsg: "保存失败",
        isSilent: false,
        isSkipIgnore: false
      };
      opt = dsf.mix(opt, options);
      try {
        let result = await this.$formSave(opt, isReturnYes);
        if (result?.data?._id) {
          if (afterCallback && dsf.isFunction(afterCallback)) {
            await afterCallback(result);
          }
          this.$dataKey = result?.data?._id || "";
          for (const k in result?.data) {
            this.$set(this.$viewData, k, result.data[k]);
          }
          if (opt.savedClose) {
            this.closeForm();
          } else {
            this.$updateUrl(result?.data || {});
          }
        }
        return result;
      } catch (ex) {
        dsf.error(ex);
        throw ex;
      }
    },
    closeForm(callback){
      this.loading = true;
      const clearId = window.setTimeout(() => {
        this.loading = false;
        this.$closeWindow && this.$closeWindow();
        clearId && clearTimeout(clearId);
        callback?.();
      }, this.savedCloseTime);
    },
    /**
     * 表单保存
     * @param {*} options
     * @returns
     */
    async $formSave(options = {}) {
      let saveResult = null;
      let saveComplete = this.$options.saveComplete;
      try {
        // 清空所有校验错误信息
        this.resetValidate();
        // 处理控件显示逻辑
        this.showLogicHandler();
        //轮询执行所有组件提交前事件
        await this.$postBefore();
        //全局校验表单并滚动到错误组件
        await this.formValidate(options);
        //py审核检测
        this.formulaPyCheckFormDataFn && (await this.formulaPyCheckFormDataFn(options));
        // await formValidateAndScrollTo.call(this, options);
        //保存时强行结束掉所有子表的编辑状态
        _.each(this.$subTables, (sub) => {
          sub.editAllEnd && sub.editAllEnd();
        });
        // if (saveBefore) {
        //   //执行表单保存前钩子函数
        //   await promiseFn.call(this, saveBefore, [options], true);
        // }
        await common.mergeExecCycleFunctions(this, "saveBefore", [options], common.postPromiseFn);
        await this.$nextTick();
        this.loading = true;
        //表单保存
        let result = null;
        try {
          result = await this.$save(options);
        } catch (ex) {
          throw ex;
        }
        //更新表单数据
        saveResult = result;
        //轮询执行所有组件的postAfter
        await this.$postAfter(result);
        // if (saveAfter) {
        //   //执行表单保存后钩子函数
        //   await promiseFn.call(this, saveAfter, [saveResult.data, options]);
        // }
        // 新增表单保存成功后的 回调事件
        this.$emit("saveAfter", saveResult.data, options);
        await common.mergeExecCycleFunctions(
          this,
          "saveAfter",
          [saveResult.data, options],
          common.postPromiseFn
        );
        if (!options.isSilent) {
          await this.$nextTick();
          window.setTimeout(() => {
            this.$message(options.successMsg, true);
          }, 300);
        }
        return result;
      } catch (ex) {
        let throwError = null;
        let message = "";
        //表单校验错误
        if (dsf.isObject(ex) && ex.type == "ValidateError") {
          dsf.layer.message("填写内容不符合要求，请检查", false);
          // 如果有审核状态组件触发弹出
          throwError = ex;
        }
        //钩子函数执行规则为false
        if (dsf.isObject(ex) && ex.type == "nextFalse") {
          throwError = ex;
        }
        //抛出错误代码，有state表示后端返回的错误，20001的话提示报错错误,其他的显示后端返回的错误代码
        else if (dsf.isObject(ex) && dsf.hasOwn(ex, "state")) {
          message = ex.state === 20001 ? options.errorMsg : ex.message;
          throwError = ex;
        }
        //如果错误直接是文本，直接提示错误
        else if (dsf.type(ex) === "string") {
          message = ex;
          throwError = ex;
        }
        //程序出现错误
        else if (dsf.type(ex) === "error") {
          message = options.errorMsg;
          throwError = ex;
        }
        if (message) {
          await this.$nextTick();
          window.setTimeout(() => {
            this.$message(message, false);
          }, 300);
        }
        saveResult = null;
        //轮询执行所有组件的postError
        await this.$postError();
        if (throwError) {
          throw throwError;
        }
      } finally {
        if (saveResult?.data) {
          this.$data._postState = "FORMSAVE";
          this.$data._postState = "";
        }
        this.ignoreValidate = false;
        if (options.isRefresh && saveResult?.data?._id) {
          this.reloadParentViewData();
        }
        if (saveComplete) {
          //执行表单保存完成（无论成功失败）的钩子函数
          saveComplete.call(this, saveResult);
        }
        this.loading = false;
        saveResult = null;
        delete this.__showLogicRecordCtrl__;
      }
    },
    /**
     * 获取保存函数接口数据
     * @param {*} options
     * @returns
     */
    async $getSaveParams(options) {
      let _this = this;
      let data = this.$getPostData(options);
      let postDataBefore = this.$options.postDataBefore;
      let postDataAfter = this.$options.postDataAfter;

      //数据被提交前的处理
      // if (postDataBefore) {
      //   await promiseFn.call(this, postDataBefore, [data, options]);
      // }
      await common.mergeExecCycleFunctions(
        this,
        "postDataBefore",
        [data, options],
        common.postPromiseFn
      );
      let params = {
        namespace: this.nameSpace,
        pageName: this.pageName,
        data: data,
        attach: JSON.stringify({})
      };
      if (this.$dataKey) {
        params.data["_id"] = this.$dataKey;
      }
      //保存时参数处理
      let saveParams = this.getSavePostParams;
      if (saveParams) {
        saveParams.call(this, params);
      }
      params.data = this.$postDataToJson(params.data);
      return params;
    },

    /**
     * 调用保存服务
     * @param {*} options
     * @returns
     */
    async $save(options) {
      const params = await this.$getSaveParams(options);
      try {
        //调用接口
        let result = await this.saveAPI(params);
        if (result && result.data) {
          let data = result.data;
          let successCode = "20000";
          if (data.state == successCode) {
            _.each(this.$subTables, (table) => {
              table.deleted = [];
            });
          }
          // if (postDataAfter) {
          //   //提交后的数据处理
          //   await promiseFn.call(this, postDataAfter, [data, options]);
          // }
          await common.mergeExecCycleFunctions(
            this,
            "postDataAfter",
            [data, options],
            common.postPromiseFn
          );
          if (data.state == successCode) {
            return data;
          } else {
            throw data;
          }
        }
      } catch (err) {
        throw err;
      }
    },

    /**
     * 表单保存成功后获取保存结果中的主键更新url中的id参数
     * @param {*} result
     */
    $updateUrl(result) {
      let id = result?._id || "";
      if (id) {
        if (this?.$frame?.independent) {
          this.$frame.urlChange(
            {
              pageName: this.pageName,
              nameSpace: this.nameSpace,
              query: { ...this.$localParams, id: id }
            },
            true
          );
        }
        //如果页面在dialog中不更新url中的id参数
        else if (this.$dialog) {
          // this.queryString.id = result._id;
          let pageName = this.$dialog.currentView.pageName;
          let nameSpace = this.$dialog.currentView.nameSpace;
          let localParams = this.$dialog.currentView.localParams;
          this.$dialog.currentView &&
            this.$dialog.currentView.urlChange(
              {
                pageName: pageName,
                nameSpace: nameSpace,
                query: { ...localParams, id: id }
              },
              true
            );
        } else {
          let params = dsf.mix({}, this.$route.query, {
            id: result._id
          });
          //更新url添加id参数
          this.$router.replace({
            path: this.$route.path,
            query: params
          });
        }
      }
    },
    /**
     * 获取当前页面子表
     * @param {*} key
     * @returns
     */
    getSubTable(key) {
      return _.find(this.$subTables, (it) => {
        return it.metadata_fullcode == key;
      });
    },
    async yes() {
      try {
        // 清空所有校验错误信息
        this.resetValidate();
        // 处理控件显示逻辑
        this.showLogicHandler();
        //轮询执行所有组件提交前事件
        await this.$postBefore();
        //全局校验并滚动到错误组件
        await this.formValidate();
        let data = this.$getPostData();
        return data;
      } catch (ex) {
        dsf.error(ex);
        this.$postError();
        return false;
      } finally {
        delete this.__showLogicRecordCtrl__;
      }
    },
    /**
     * 保存服务api
     * @param {*} params
     * @returns
     */
    saveAPI(params) {
      return this.$webAPI.formSave(params, true);
    },
    /**
     * 获取表单数据API接口
     * @param {*} params
     * @returns
     */
    $getFormDataAPI(params) {
      return this.$webAPI.getFormData(params, true);
    },
    /**
     * 获取提交数据
     * @param {*} options
     * @returns
     */
    $getPostData(options = {}) {
      let _this = this;
      let data = dsf.mix(true, {}, this.$viewData);
      //同步主表枚举字段选项的冗余字段
      this.$asyncItemFields(data);
      let mainFields = _.filter(this.$postFields, (it) => {
        return it.isFormControl && !it.isOneToMany && !it.metadata.inSubTable;
      });
      mainFields = _.keyBy(mainFields, "designId");
      //处理子表数据
      _.each(this.$subTables, (table) => {
        let key = table.metadata_fullcode;
        let tableData = data[key] || [];
        if (tableData.length == 1) {
          //判断当前行是否所有值都为空
          if (tableData[0]?.$hash?.startsWith?.(dsf.global.$const.subTableEmptyRowHash)) {
            let isEmpty = table.isEmptyData(tableData[0]);
            isEmpty && (tableData = []);
          }
        }
        //循环子表数据增加后端需要的相关属性
        _.each(tableData, (row, i) => {
          if (row[key + ".ds_deleted"] != 1) {
            row[key + ".ds_deleted"] = 0;
          }
          if (table.autoOrder) {
            row[key + ".ds_order"] = i;
          }
          //同步子表枚举字段选项的冗余字段
          this.$asyncItemFields(row);
          // //子表冗余主表字段处理
          // if (table.redundanceFields && table.redundanceFields.length > 0) {
          //   _.each(table.redundanceFields, (designId) => {
          //     let com = mainFields[designId];
          //     if (com) {
          //       let value = com?.value;
          //       row[key + ".main_" + com.metadata.code] = value;
          //     }
          //   });
          // }
        });
        //合并提交子表中的汇总行数据
        if (table.openTotalRow && table.totlResultPost && table.totalData && tableData.length) {
          let totalKey = key + "." + table.totalRowFieldKey;
          //移除掉所有数据中垃圾汇总行
          dsf.array.removeWith(tableData, (it) => {
            return it[totalKey] == table.totalRowFieldTrueValue;
          });
          table.totalData[key + ".ds_order"] = tableData.length;
          if (
            table.totalData[key + ".ds_deleted"] == "" ||
            table.totalData[key + ".ds_deleted"] == undefined
          )
            table.totalData[key + ".ds_deleted"] = 0;
          table.totalData[totalKey] = table.totalRowFieldTrueValue;
          tableData = [...tableData, table.totalData];
        }
        //将被用户做过删除操作的数据合并到数据中提交给后端
        if (table.deleted) {
          let deletedRows = [];
          _.each(table.deleted, (delRow) => {
            if (delRow["_id"]) {
              let row = _.find(tableData, (row) => row["_id"] == delRow["_id"]);
              if (!row) {
                delRow[key + ".ds_deleted"] = 1;
                deletedRows.push(delRow);
              }
            }
          });
          data[key] = [...tableData, ...deletedRows];
        }
        //清理掉子表提交数据中需要排除的字段
        _.each(data[key], (row) => {
          let ignoreFields = null;
          if (dsf.isFunction(table.ignoreFields)) {
            ignoreFields = table.ignoreFields() || [];
          } else {
            ignoreFields = table.ignoreFields || [];
          }
          _.each(ignoreFields, (it) => {
            delete row[it];
          });
        });
      });
      this.$filterInValidMetaDataValueAttrs(data);
      return data;
    },
    /**
     * 处理提交数据转为json
     * @param {*} data
     * @param {*} ignoreSystemField
     * @returns
     */
    $postDataToJson(data, ignoreSystemField = true) {
      let _this = this;
      let systemKeys = [
        dsf.config.kw.updatetime,
        dsf.config.kw.updateusername,
        dsf.config.kw.updateuserid,
        dsf.config.kw.createuserid,
        dsf.config.kw.createusername,
        dsf.config.kw.createtime
      ];
      let jsonStr = JSON.stringify(data, function (key, val) {
        // $开头的数据为前端产生的结构，不提交服务器否则会导致服务端
        if (!key.startsWith("$")) {
          let ignore = false;
          if (_this.metadataDict?.[key]?.allowPost === false) {
            ignore = true;
          }
          if (!ignore && ignoreSystemField) {
            //判断当前key是否是系统字段，如果是则忽略
            ignore = _.find(systemKeys, (it) => key.endsWith(`.${it}`));
          }
          return ignore ? undefined : val;
        }
        return undefined;
      });
      return jsonStr;
    },
    /**
     * 过滤提交数据中的非元数据属性
     * @param {*} data
     */
    $filterInValidMetaDataValueAttrs(data) {
      _.forOwn(data, (v, key) => {
        if (this.metadataDict[key]) {
          let meta = this.metadataDict[key];
          let va = meta.valueAttributes;
          if (meta.type == "field") {
            if (va.length > 1) {
              filterInValidValueAttr(meta, v);
            }
          } else if (meta.type == "subtable") {
            if (dsf.isDef(v)) {
              _.each(v, (row, i) => {
                this.$filterInValidMetaDataValueAttrs(row);
              });
            }
          }
        }
      });
    },
    $getValidateMetaList() {
      return this.$metadataKeyList;
    },
    //同步数据中枚举类每个选项的冗余字段
    $asyncItemFields(data) {
      for (const k in data) {
        let meta = this.metadataDict[k];
        if (!meta?.disperseFields && (meta?.itemFields || []).length <= 0) {
          continue;
        }
        let itemFields = meta.itemFields;
        _.each(itemFields, (it, i) => {
          let value = data[k];
          value = dsf.isDef(value) && dsf.isArray(value) ? value : [value];
          value = _.map(value, meta.valueField || "value");
          let v = value.indexOf(it.itemValue) >= 0 ? it.itemValue : "";
          data[it.key] = v;
        });
      }
    },
    // 处理控件显示逻辑
    showLogicHandler() {
      let __showLogicRecordCtrl__ = {}; // 记录被隐藏的控件
      let { showLogicCompile, ctrlTreeInfo, $controls, $controlsMapping, $viewData } = this;

      _.each(showLogicCompile, (fn, designId) => {
        let ctrl = $controls[designId];
        let inSubTable = ctrl.metadata.inSubTable;
        // 非子表内的控件
        if (!inSubTable) {
          // 如果控件被隐藏，则跳过
          if (__showLogicRecordCtrl__[designId]) return;

          let isShow = fn.call(this, $viewData);
          if (!isShow) {
            // 递归打标记
            let children = { [designId]: ctrlTreeInfo[designId] };
            while (_.keys(children).length) {
              let arr = {};
              _.each(children, (c, id) => {
                __showLogicRecordCtrl__[id] = true;
                if (!isSubTable($controls[id])) {
                  Object.assign(arr, c);
                }
                clearFormValueByCtrl($viewData, $controls[id]);
              });
              children = arr;
            }
          }
        }
        // 子表内的控件
        else {
          let subTableDesignId = $controlsMapping[inSubTable];
          // 如果子表被隐藏，则跳过
          if (__showLogicRecordCtrl__[subTableDesignId]) return;

          let subTableValue = $viewData[inSubTable];
          if (subTableValue?.length) {
            _.each(subTableValue, (row) => {
              if (__showLogicRecordCtrl__[designId]?.[row.$hash]) return;

              let isShow = fn.call(this, $viewData, row);
              if (!isShow) {
                // 递归打标记
                let children = { [designId]: ctrlTreeInfo[designId] };
                while (_.keys(children).length) {
                  let arr = {};
                  _.each(children, (c, id) => {
                    if (!__showLogicRecordCtrl__[id]) {
                      __showLogicRecordCtrl__[id] = {};
                    }
                    __showLogicRecordCtrl__[id][row.$hash] = true;
                    Object.assign(arr, c);
                    clearFormValueByCtrl(row, $controls[id]);
                  });
                  children = arr;
                }
              }
            });
          }
        }
      });

      this.__showLogicRecordCtrl__ = __showLogicRecordCtrl__;
    }
  },
  watch: {
    //如果参数id变化更新$dataKey
    "queryString.id": function (v) {
      this.$isForm && (this.$dataKey = v);
    }
  }
};

/**
 * 判断控件是否是子表
 * @param ctrl
 * @returns {boolean}
 */
function isSubTable(ctrl) {
  return ctrl.isOneToMany && ctrl.isFormControl; //ctrl.ctrlType == "dsf.subtable" || ctrl.ctrlType == "dsf.mobile.subtable";
}

/**
 * 清空表单值
 * @param data
 * @param ctrl
 */
function clearFormValueByCtrl(data, ctrl) {
  if (!ctrl.isFormControl) return;
  let fullcode = ctrl.metadata_fullcode;
  if (isSubTable(ctrl)) {
    data[fullcode] = [];
  } else {
    let valueAttributes = ctrl.metadata.valueAttributes;
    if (valueAttributes.length > 1) {
      // todo 这里清空的默认值不确定
      let val = {};
      _.each(valueAttributes, ({ code }) => (val[code] = ""));
      data[fullcode] = val;
    } else {
      data[fullcode] = "";
    }
  }
}

//过滤值属性
function filterInValidValueAttr(meta, v) {
  let va = meta.valueAttributes;
  if (dsf.isObject(v)) {
    for (const k in v) {
      if (!~va.indexOf(k)) {
        delete v[k];
      }
    }
  } else if (dsf.isArray(v)) {
    _.each(v, (cv, i) => {
      if (dsf.isObject(cv)) {
        for (const k in cv) {
          if (!~va.indexOf(k)) {
            delete cv[k];
          }
        }
      }
    });
  }
}
export default form;
